// src/pages/ForumsBeitragsPage.js
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './ForumsBeitragsPage.css';
import SpeechIcon from "../components/SpeechIcon";
import ContentActionMenu from "../components/ContentActionMenu";
import { useBlockedUsers } from "../hooks/useBlockedUsers";



import { useAuth } from "../auth/AuthProvider";

import {
  sendPlatformMessageData
} from "../services/messagesDataService";

import {
  getForumPostByIdData,
  getForumRepliesData,
  updateForumPostData,
  deleteForumPostData,
  createForumReplyData,
  updateForumReplyData,
  deleteForumReplyData,
  toggleForumSubscriptionData,
  uploadForumImagesData,
  markForumRepliesSeenData
} from "../services/forumDataService";

import { getUserProfileData } from "../services/profileDataService";

import GateIcon from '../components/GateIcon';
import OfflineBanner from '../components/OfflineBanner';
import { isNativeMobileApp, makeNativeImageEntries } from "../utils/nativeImagePicker";
import ImageSourceModal from "../components/ImageSourceModal";


const MAX_REPLY_IMAGES = 5;



/** ✅ Abo: Union aus neuen + legacy Feldern */
const getSubscribersUnion = (postData) => {
  const a = Array.isArray(postData?.subscribers) ? postData.subscribers : [];
  const b = Array.isArray(postData?.subscribedBy) ? postData.subscribedBy : [];
  return Array.from(new Set([...(a || []), ...(b || [])]));
};

const isSubscribedByMe = (postData, myUid, isVerified) => {
  if (!myUid || !isVerified) return false;
  return getSubscribersUnion(postData).includes(myUid);
};


const ForumsBeitragsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

 const { user } = useAuth();

const myUid = user?.uid || null;
const myEmail = user?.email || "";
const isVerified = user?.emailVerified === true;
const { filterBlocked, addBlockedUser } = useBlockedUsers(myUid, isVerified);

  // ✅ Admin-Flag (Custom Claim)
  const [isAdmin, setIsAdmin] = useState(false);

  // ✅ Profilname (nutzer/{uid}.name)
  const [myProfileName, setMyProfileName] = useState('');
  const myName =
    myProfileName ||
    user?.displayName ||
    (user?.email ? user.email.split('@')[0] : '') ||
    'Unbekannt';

  const [post, setPost] = useState(null);
  const [replies, setReplies] = useState([]);

  // ✅ getrennte Ladezustände (Post zuerst, Replies danach)
  const [postLoading, setPostLoading] = useState(true);
  const [repliesLoading, setRepliesLoading] = useState(true);

  // ✅ Loading-Text erst nach kurzer Verzögerung anzeigen (kein “Mini-Loading”)
  const [showLoadingHint, setShowLoadingHint] = useState(false);

  const [loadError, setLoadError] = useState('');

  const [newReply, setNewReply] = useState('');

  // Reply-Bilder: [{ file, preview }]
  const [replyImages, setReplyImages] = useState([]);
  const [mainReplyImageIndex, setMainReplyImageIndex] = useState(null);

  const [showSendModal, setShowSendModal] = useState(false);
  const [showCreatingReplyModal, setShowCreatingReplyModal] = useState(false);
const [creatingReplyText, setCreatingReplyText] = useState("");
  const [replyToDelete, setReplyToDelete] = useState(null);

  const [subscriptionMessage, setSubscriptionMessage] = useState('');
const [lightboxIndex, setLightboxIndex] = useState(null);
const [lightboxImages, setLightboxImages] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);

  const [showMessageModal, setShowMessageModal] = useState(false);
  const [modalRecipient, setModalRecipient] = useState({ id: '', name: '' }); // uid + name
  const [newMessageText, setNewMessageText] = useState('');

  const [replyBeingEdited, setReplyBeingEdited] = useState(null);
  const [editedText, setEditedText] = useState('');

  // ✅ Edit-Felder für Hauptbeitrag
  const [editedTitle, setEditedTitle] = useState('');
  const [editedCategory, setEditedCategory] = useState('');

  const [uploadLimitExceeded, setUploadLimitExceeded] = useState(false);
const [showImageSourceModal, setShowImageSourceModal] = useState(false);
const [imageSourceTarget, setImageSourceTarget] = useState(null);

// 🔐 Login-Pflicht-Popup
const [showLoginRequiredModal, setShowLoginRequiredModal] = useState(false);

  // 🌐 OfflineBanner-Status (nur Anzeige)
  const [isOffline, setIsOffline] = useState(false);
  const [retryAttempt, setRetryAttempt] = useState(0);

  // ✅ getrennte refs für Uploads (wichtig!)
  const replyFileInputRef = useRef(null);
  const mainPostFileInputRef = useRef(null);
  const [mainPostNewImages, setMainPostNewImages] = useState([]);

const dragItem = useRef(null);
const dragOverItem = useRef(null);
const lightboxRef = useRef(null);

/**
 * ✅ Date Picker Trigger (Mobile-safe)
 * - gleiche Datei erneut auswählbar
 * - Kamera wird NICHT erzwungen
 */
const triggerImagePicker = (inputRef, modalTarget = null) => {
  if (isNativeMobileApp()) {
    if (!modalTarget) return; // ✅ FIX
    setImageSourceTarget(modalTarget);
    setShowImageSourceModal(true);
    return;
  }

  const el = inputRef?.current;
  if (!el) return;
  el.value = null;
  el.removeAttribute("capture");
  el.click();
};
  
const toDisplayMillis = (value) => {
  if (!value) return 0;

  if (typeof value === "number") return value;

  if (typeof value === "string") {
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  if (typeof value.toMillis === "function") {
    return value.toMillis();
  }

  if (typeof value.seconds === "number") {
    return value.seconds * 1000;
  }

  return 0;
};

const formatCreatedDate = (item) => {
  const millis =
    toDisplayMillis(item?.createdAt) ||
    toDisplayMillis(item?.createdAtClient) ||
    toDisplayMillis(item?.createdAtMs);

  if (!millis) return "";

  return new Date(millis).toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};
  const repliesPerPage = 20;

const visibleReplies = filterBlocked(replies);

const totalPages = Math.max(
  1,
  Math.ceil(visibleReplies.length / repliesPerPage) || 1
);

const pagedReplies = visibleReplies.slice(
  (currentPage - 1) * repliesPerPage,
  currentPage * repliesPerPage
);

  // ✅ Loading-Hint erst nach 300ms anzeigen
  useEffect(() => {
    setShowLoadingHint(false);
    const t = setTimeout(() => setShowLoadingHint(true), 300);
    return () => clearTimeout(t);
  }, [id]);

  // ✅ Admin-Claim laden
 useEffect(() => {
  const loadAdminClaim = async () => {
    try {
      if (!user?.uid || typeof user.getIdTokenResult !== "function") {
        setIsAdmin(false);
        return;
      }

      const token = await user.getIdTokenResult(true);
      setIsAdmin(token?.claims?.admin === true);
    } catch (e) {
      setIsAdmin(false);
    }
  };

  loadAdminClaim();
}, [user?.uid]);

  // 🔍 Verbindung für OfflineBanner prüfen
  useEffect(() => {
    const checkConnection = async () => {
      try {
        await fetch('https://www.gstatic.com/firebasejs/9.6.1/firebase-app.js', {
          method: 'HEAD',
          cache: 'no-store',
        });
        setIsOffline(false);
      } catch (err) {
        console.warn('Keine Server-Verbindung möglich (ForumsBeitragsPage):', err);
        setIsOffline(true);
      }
    };
    checkConnection();
  }, [retryAttempt]);

  const handleOfflineRetry = () => {
    setIsOffline(false);
    setTimeout(() => setRetryAttempt((prev) => prev + 1), 600);
  };
const showActionToast = (text) => {
  setSubscriptionMessage(text);
  setTimeout(() => setSubscriptionMessage(""), 2500);
};
  // ✅ Profilname laden (nutzer/{uid}.name)
  useEffect(() => {
    const loadMyName = async () => {
      if (!myUid || !isVerified) {
        setMyProfileName('');
        return;
      }
      try {
        const profile = await getUserProfileData(myUid);
        const name = String(profile?.name || "").trim();
        setMyProfileName(name);
      } catch (e) {
        setMyProfileName('');
      }
    };
    loadMyName();
  }, [myUid, isVerified]);

  // ✅ Autor ODER Admin darf edit/delete
  const canEdit = (authorId) => {
    if (!myUid || !isVerified) return false;
    if (isAdmin) return true;
    if (!authorId) return false;
    return authorId === myUid;
  };

  // ✅ Post zuerst laden (schnell) – Replies danach separat
  useEffect(() => {
    const fetchPostFirst = async () => {
      setLoadError('');
      setPostLoading(true);
      setRepliesLoading(true);

      if (!id) {
        setPost(null);
        setReplies([]);
        setPostLoading(false);
        setRepliesLoading(false);
        setLoadError('Beitrag-ID fehlt.');
        return;
      }

      try {
        const postData = await getForumPostByIdData(id);

if (!postData) {
  setPost(null);
  setReplies([]);
  setPostLoading(false);
  setRepliesLoading(false);
  setLoadError('Dieser Beitrag existiert nicht (mehr).');
  return;
}

const safePost = {
  ...postData,
  subscribed: isSubscribedByMe(postData, myUid, isVerified),
};

setPost(safePost);
      } catch (error) {
        console.error('Fehler beim Laden des Posts:', error);
        setPost(null);
        setReplies([]);
        setLoadError('Beitrag konnte nicht geladen werden. Bitte erneut versuchen.');
      } finally {
        setPostLoading(false);
      }
    };

    fetchPostFirst();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, myUid, isVerified, retryAttempt]);

  // ✅ Replies nachladen (UI bleibt sichtbar)
  useEffect(() => {
    const fetchReplies = async () => {
      if (!id) return;
      if (!post) return;

      setRepliesLoading(true);
      try {
        const repliesList = await getForumRepliesData(id);

setReplies(repliesList);

        setCurrentPage((prev) => {
  const visibleList = filterBlocked(repliesList);
  const newTotal = Math.max(
    1,
    Math.ceil(visibleList.length / repliesPerPage) || 1
  );

  return Math.min(prev, newTotal);
});
      } catch (error) {
        console.error('Fehler beim Laden der Replies:', error);
      } finally {
        setRepliesLoading(false);
      }
    };

    fetchReplies();
  }, [id, post?.id, filterBlocked]);

  useEffect(() => {
    if (lightboxIndex !== null && lightboxRef.current) lightboxRef.current.focus();
  }, [lightboxIndex]);

  useEffect(() => {
  if (!post?.id || !myUid) return;

  markForumRepliesSeenData(post.id, replies);
}, [post?.id, replies, myUid]);

  // 🔔 Abo toggle: schreibt IMMER beide Felder (subscribers + subscribedBy)
  const handleSubscriptionToggle = async () => {
    if (!post) return;

    if (!myUid || !isVerified) {
      setShowLoginRequiredModal(true);
      return;
    }
  

    const newStatus = !post.subscribed;

    // UI sofort (Union-Array pflegen)
    setPost((prev) => {
      const current = Array.isArray(prev.subscribers) ? prev.subscribers : [];
      const next = newStatus
        ? Array.from(new Set([...current, myUid]))
        : current.filter((x) => x !== myUid);

      return { ...prev, subscribed: newStatus, subscribers: next };
    });

    setSubscriptionMessage(`Beitrag wurde ${newStatus ? 'abonniert' : 'nicht mehr abonniert'}.`);
    setTimeout(() => setSubscriptionMessage(''), 2500);

    try {
     await toggleForumSubscriptionData(post.id, myUid, newStatus);
    } catch (err) {
      console.warn('⚠️ Abo konnte nicht gespeichert werden:', err);
    }
  };

  const handleEditReply = (reply) => {
    setReplyBeingEdited(reply.id);
    setEditedText(reply.content);

    if (reply.id === 'main') {
      setEditedTitle(post?.title || '');
      setEditedCategory(post?.category || '');
    }
  };

  const confirmEditReply = async (editId) => {
    if (!post) return;

    if (!myUid || !isVerified) {
      setShowLoginRequiredModal(true);
      return;
    }

    if (editId === 'main') {
      if (!canEdit(post.authorId || post.userId)) {
        alert('Du kannst diesen Beitrag nicht bearbeiten.');
        return;
      }

      if (!String(editedTitle || '').trim() || !String(editedCategory || '').trim()) {
        alert('Titel und Kategorie dürfen nicht leer sein.');
        return;
      }

      let imageUrls = (post.images || []).filter(
  (url) =>
    !String(url).startsWith("blob:") &&
    !String(url).startsWith("data:")
);

const newUploads = Array.isArray(mainPostNewImages)
  ? mainPostNewImages
      .map((entry) => entry?.file)
      .filter((file) => file instanceof File || file instanceof Blob)
  : [];

if (newUploads.length > 0) {
  try {
    const uploadedUrls = await uploadForumImagesData(
  newUploads,
  `forumPosts/${myUid}/posts/${post.id}`
);

    imageUrls = [...imageUrls, ...uploadedUrls];
  } catch (err) {
    console.error("Fehler beim Aktualisieren der Hauptbeitrag-Bilder:", err);
  }
}

try {
  await updateForumPostData(post.id, {
  title: String(editedTitle).trim(),
  category: String(editedCategory).trim(),
  content: String(editedText || '').trim(),
  images: imageUrls,
});
} catch (err) {
  console.error('Fehler beim Aktualisieren des Beitrags:', err);
}

setPost((prev) => ({
  ...prev,
  title: String(editedTitle).trim(),
  category: String(editedCategory).trim(),
  content: String(editedText || '').trim(),
  images: imageUrls,
}));

setMainPostNewImages([]);
if (mainPostFileInputRef.current) {
  mainPostFileInputRef.current.value = null;
}
    } else {
      const target = replies.find((r) => r.id === editId);
      if (!target) return;

      if (!canEdit(target.authorId || target.userId)) {
        alert('Du kannst diese Antwort nicht bearbeiten.');
        return;
      }

      const updatedList = replies.map((r) => (r.id === editId ? { ...r, content: editedText } : r));
      setReplies(updatedList);

      try {
        await updateForumReplyData(post.id, editId, {
  content: editedText,
});
      } catch (err) {
        console.error('Fehler beim Speichern der Antwort-Änderung:', err);
      }
    }

    setReplyBeingEdited(null);
    setEditedText('');
  };

  const handleSendReply = async () => {
    if (!newReply.trim()) {
      setShowSendModal(false);
      return;
    }

    if (!myUid || !isVerified) {
      setShowSendModal(false);
      setShowLoginRequiredModal(true);
      return;
    }
    setShowCreatingReplyModal(true);

setCreatingReplyText(
  replyImages.length > 0
    ? "Antwort wird erstellt. Der Bilder-Upload kann einen Moment dauern…"
    : "Antwort wird erstellt…"
);

    let imageUrls = [];
    if (replyImages.length > 0) {
      try {
        const files = replyImages.map((e) => e.file).filter((f) => f instanceof File);
        if (files.length) imageUrls = await uploadForumImagesData(
  files,
  `forumPosts/${myUid}/replies/${post.id}`
);
      } catch (err) {
        console.error('Fehler beim Hochladen von Antwort-Bildern:', err);
        imageUrls = [];
      }
    }

    const replyData = {
  content: newReply.trim(),
  authorId: myUid,
  userId: myUid,
  authorName: myName,
  images: imageUrls,
};

    try {
      const newReplyId = await createForumReplyData(post.id, replyData);

setReplies((prev) => [...prev, { id: newReplyId, ...replyData }]);

      setNewReply('');
      setReplyImages([]);
      setMainReplyImageIndex(null);
      setShowSendModal(false);
setShowCreatingReplyModal(false);
    } catch (error) {
      console.error('Fehler beim Speichern der Antwort:', error);
      alert('Antwort konnte nicht gespeichert werden. Bitte erneut versuchen.');
      setShowSendModal(false);
setShowCreatingReplyModal(false);
    }
  };

  const handleDeleteReply = async (deleteId) => {
    try {
      if (!post) return;

      if (!myUid || !isVerified) {
        setShowLoginRequiredModal(true);
        return;
      }

      if (deleteId === 'main') {
        if (!canEdit(post.authorId || post.userId)) {
          alert('Du kannst diesen Beitrag nicht löschen.');
          return;
        }
        await deleteForumPostData(post.id);
        navigate('/forum');
      } else {
        const target = replies.find((r) => r.id === deleteId);
        if (!target) return;

        if (!canEdit(target.authorId || target.userId)) {
          alert('Du kannst diese Antwort nicht löschen.');
          return;
        }

        await deleteForumReplyData(post.id, deleteId);
        setReplies((prev) => prev.filter((r) => r.id !== deleteId));
      }
    } catch (error) {
      console.error('Fehler beim Löschen:', error);
      alert('Löschen fehlgeschlagen.');
    } finally {
      setReplyToDelete(null);
    }
  };

  // Reply-Bilder-Upload (max 5, EE-Popup)
 const handleImageUpload = async (e, source = "gallery") => {
  const remaining = MAX_REPLY_IMAGES - replyImages.length;
  if (remaining <= 0) {
    setUploadLimitExceeded(true);
    return;
  }

  let newEntries = [];

  if (isNativeMobileApp() && (!e?.target?.files || e.target.files.length === 0)) {
    try {
      newEntries = await makeNativeImageEntries({
  prefix: "reply",
  source,
  limit: remaining,
});
    } catch (err) {
      console.warn("Native Bildauswahl abgebrochen:", err);
      return;
    }
  } else {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    const take = files.slice(0, remaining);
    newEntries = take.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
  }

  setReplyImages((prev) => {
    const updated = [...prev, ...newEntries];

    if (mainReplyImageIndex === null && updated.length > 0) {
      setMainReplyImageIndex(0);
    }

    return updated;
  });

  if (e?.target) e.target.value = null;
};

  const handleDeleteImage = (index) => {
    setReplyImages((prev) => {
      const updated = prev.filter((_, i) => i !== index);

      let newMain = mainReplyImageIndex;
      if (mainReplyImageIndex === index) newMain = updated.length > 0 ? 0 : null;
      else if (mainReplyImageIndex > index) newMain = mainReplyImageIndex - 1;

      setMainReplyImageIndex(newMain);
      return updated;
    });
  };

const handleMainPostImageUploadNative = async (source = "gallery") => {
  if (!post) return;

  const existingCount = Array.isArray(post.images) ? post.images.length : 0;
  const pendingCount = Array.isArray(mainPostNewImages) ? mainPostNewImages.length : 0;
  const remaining = MAX_REPLY_IMAGES - existingCount - pendingCount;

  if (remaining <= 0) {
    setUploadLimitExceeded(true);
    return;
  }

  try {
    const entries = await makeNativeImageEntries({
      prefix: "main-post",
      source,
      limit: remaining,
    });

    if (!entries.length) return;

    setMainPostNewImages((prev) => [...prev, ...entries]);

    setPost((prev) => ({
      ...prev,
      images: [...(prev.images || []), ...entries.map((entry) => entry.preview)],
    }));

    if (mainPostFileInputRef.current) {
      mainPostFileInputRef.current.value = null;
    }
  } catch (err) {
    console.warn("Native Bildauswahl Hauptbeitrag abgebrochen:", err);
  }
};
const handleChooseCamera = () => {
  const target = imageSourceTarget;
  setShowImageSourceModal(false);
  setImageSourceTarget(null);

  requestAnimationFrame(() => {
    if (target === "main-post") {
      handleMainPostImageUploadNative("camera");
    } else {
      handleImageUpload({}, "camera");
    }
  });
};

const handleChooseGallery = () => {
  const target = imageSourceTarget;
  setShowImageSourceModal(false);
  setImageSourceTarget(null);

  requestAnimationFrame(() => {
    if (target === "main-post") {
      handleMainPostImageUploadNative("gallery");
    } else {
      handleImageUpload({}, "gallery");
    }
  });
};

  const handleDragStart = (e, index) => {
    dragItem.current = index;
  };

  const handleDrop = (e, index) => {
    const from = dragItem.current;
    if (from === null || from === index) return;

    const copied = [...replyImages];
    const draggedItem = copied[from];
    copied.splice(from, 1);
    copied.splice(index, 0, draggedItem);

    setReplyImages(copied);

    setMainReplyImageIndex((prev) => {
      if (prev === null) return prev;
      if (prev === from) return index;
      if (prev === index) return from;
      if (from < prev && index >= prev) return prev - 1;
      if (from > prev && index <= prev) return prev + 1;
      return prev;
    });

    dragItem.current = null;
    dragOverItem.current = null;
  };

  const showPrevImage = () => {
  if (!lightboxImages?.length) return;
  setLightboxIndex((prev) => (prev === 0 ? lightboxImages.length - 1 : prev - 1));
};

const showNextImage = () => {
  if (!lightboxImages?.length) return;
  setLightboxIndex((prev) => (prev === lightboxImages.length - 1 ? 0 : prev + 1));
};

  // Autorname klickbar → Nachricht an authorId
  const handleUserClick = (recipientId, recipientName, e) => {
    e.stopPropagation();

    if (!myUid || !isVerified) {
      setShowLoginRequiredModal(true);
      return;
    }
    if (!recipientId) {
      alert('Empfänger konnte nicht ermittelt werden (authorId/userId fehlt).');
      return;
    }

    setModalRecipient({ id: recipientId, name: recipientName || 'Unbekannt' });
    setShowMessageModal(true);
    setNewMessageText('');
  };

  const handleSendMessage = async () => {
    const text = newMessageText.trim();
    if (!text) return;

    if (!myUid || !isVerified) {
      setShowMessageModal(false);
      setShowLoginRequiredModal(true);
      return;
    }

    try {
      await sendPlatformMessageData({
        senderId: myUid,
        recipientId: modalRecipient.id,
        senderEmail: myUid ? (myEmail || '') : '',
        recipientEmail: '',
        senderName: myName,
        recipientName: modalRecipient.name || 'Unbekannt',
        text,
        contextType: 'forumPost',
        contextId: post?.id || null,
      });
    } catch (err) {
      console.warn('⚠️ Nachricht konnte nicht zentral gespeichert werden:', err);
      alert('Nachricht konnte nicht gesendet werden. Bitte erneut versuchen.');
    }

    setNewMessageText('');
    setShowMessageModal(false);
  };

  // ✅ Fehlerseite (wenn Post nicht geladen werden konnte)
  if (loadError) {
    return (
      <div className="forum-container">
        {isOffline && <OfflineBanner onRetry={handleOfflineRetry} />}

        <img
          src="/logo-edens-ernte-transparent.png"
          alt="Logo"
          className="browse-logo"
          onClick={() => navigate('/')}
        />
        <GateIcon className="login-icon" />
        <img
          src="/rezept-icon.png"
          alt="Rezepthelfer Icon"
          className="rezept-icon"
          onClick={() => navigate('/rezepte')}
        />
        <p className="top-claim">Zusammen wachsen – im Forum!</p>
        <div className="page-background" />

        <div className="forum-main-box">
          
          <p style={{ textAlign: 'center', opacity: 0.85 }}>{loadError}</p>
          <button className="green-button" onClick={() => setRetryAttempt((p) => p + 1)}>
            Erneut versuchen
          </button>
          <button className="red-button" onClick={() => navigate('/forum')} style={{ marginTop: 10 }}>
            Zurück zum Forum
          </button>
        </div>
      </div>
    );
  }

  // ✅ Ab hier: Layout wird IMMER gerendert – selbst wenn Post noch lädt
  return (
    <div className="forum-container">
      {isOffline && <OfflineBanner onRetry={handleOfflineRetry} />}

      <img
        src="/logo-edens-ernte-transparent.png"
        alt="Logo"
        className="browse-logo"
        onClick={() => navigate('/')}
      />
      <SpeechIcon className="speech-icon no-tap-highlight" />
      <GateIcon className="login-icon" />
      <img
        src="/rezept-icon.png"
        alt="Rezepthelfer Icon"
        className="rezept-icon"
        onClick={() => navigate('/rezepte')}
      />

      <p className="top-claim">Zusammen wachsen – im Forum!</p>
      <div className="page-background" />

      <div className="forum-main-box">
        {subscriptionMessage && (
  <div className="mainbox-toast">
    {subscriptionMessage}
  </div>
)}
        {/* ✅ Statt Return-Loading: wir zeigen nur einen Hinweis in der Box (nach 300ms) */}
        {postLoading && showLoadingHint && (
          <p className="loading-message" style={{ textAlign: 'center', opacity: 0.85 }}>
            ⏳ Beitrag wird geladen…
          </p>
        )}

        {/* Hauptbeitrag */}
        {post && (
          <div className="post-box large">
            {replyBeingEdited === 'main' ? (
              <>
                <input
                  type="text"
                  className="edit-post-title"
                  value={editedTitle}
                  onChange={(e) => setEditedTitle(e.target.value)}
                  placeholder="Titel"
                />

                <div className="edit-textarea-upload-wrapper">
  <textarea
    value={editedText}
    onChange={(e) => setEditedText(e.target.value)}
    rows="4"
  />

  {(post.images || []).length === 0 && (
  <img
    src="/upload-icon.png"
    alt="Upload"
    className="edit-textarea-upload-icon"
    onClick={() => triggerImagePicker(mainPostFileInputRef, "main-post")}
  />
)}
</div>

                <div className="image-preview-row">
                  {(post.images || []).map((src, i) => (
                    <div
                      key={i}
                      className="image-item"
                      draggable
                      onDragStart={() => (dragItem.current = i)}
                      onDragOver={(e) => {
                        e.preventDefault();
                        dragOverItem.current = i;
                      }}
                      onDrop={() => {
                        const copied = [...(post.images || [])];
                        const dragged = copied[dragItem.current];
                        copied.splice(dragItem.current, 1);
                        copied.splice(dragOverItem.current, 0, dragged);
                        setPost((prev) => ({ ...prev, images: copied }));
                      }}
                    >
                      <img src={src} alt={`edit-img-${i}`} loading="lazy" decoding="async" />
                      <div className="image-actions">
                        <button
  onClick={() => {
    setPost((prev) => {
      const currentImages = prev.images || [];
      const imageToRemove = currentImages[i];
      const filtered = currentImages.filter((_, j) => j !== i);

      setMainPostNewImages((prevNew) => {
        const entryToRemove = prevNew.find((entry) => entry.preview === imageToRemove);

        if (entryToRemove?.preview && String(entryToRemove.preview).startsWith("blob:")) {
          try {
            URL.revokeObjectURL(entryToRemove.preview);
          } catch {}
        }

        return prevNew.filter((entry) => entry.preview !== imageToRemove);
      });

      return { ...prev, images: filtered };
    });
  }}
>
  X
</button>
                      </div>
                    </div>
                  ))}

 <>
  <input
    type="file"
    accept="image/*"
    multiple
    style={{ display: 'none' }}
    ref={mainPostFileInputRef}
    onChange={(e) => {
      const files = Array.from(e.target.files || []);
      if (!files.length) return;

      const existingCount = Array.isArray(post.images) ? post.images.length : 0;
      const pendingCount = Array.isArray(mainPostNewImages) ? mainPostNewImages.length : 0;
      const remaining = MAX_REPLY_IMAGES - existingCount - pendingCount;

      if (remaining <= 0) {
        setUploadLimitExceeded(true);
        e.target.value = null;
        return;
      }

      const take = files.slice(0, remaining);

      const newEntries = take.map((file) => ({
        file,
        preview: URL.createObjectURL(file),
      }));

      setMainPostNewImages((prev) => [...prev, ...newEntries]);

      setPost((prev) => ({
        ...prev,
        images: [...(prev.images || []), ...newEntries.map((entry) => entry.preview)],
      }));

      e.target.value = null;
    }}
  />

  {(post.images || []).length > 0 && (post.images || []).length < MAX_REPLY_IMAGES && (
    <div
      className="preview-row-add-image-item"
      onClick={() => triggerImagePicker(mainPostFileInputRef, "main-post")}
    >
      <img src="/upload-icon.png" alt="Weiteres Bild hinzufügen" />
    </div>
  )}
</>
                 
                </div>

                <div className="new-post-category-wrapper">
                  <select
                    className="new-post-category-select"
                    value={editedCategory}
                    onChange={(e) => setEditedCategory(e.target.value)}
                  >
                    <option value="">Kategorie wählen…</option>
                    <option value="garten">Rund um den Garten</option>
                    <option value="kueche">Rund um die Küche</option>
                    <option value="rezepte">Diese Rezepte sind klasse!</option>
                    <option value="tauschen">Tauschen</option>
                  </select>
                  <span className="arrow-down">▼</span>
                </div>

                <button className="green-button small" onClick={() => confirmEditReply('main')}>
                  Speichern
                </button>
              </>
            ) : (
              <>
                <div className="post-actions beitrag-main-actions">
  <span
    className="bell-icon clickable"
    onClick={(e) => {
      e.stopPropagation();
      handleSubscriptionToggle();
    }}
    title={post.subscribed ? "Abo entfernen" : "Beitrag abonnieren"}
  >
    {post.subscribed ? "🔔" : "🔕"}
  </span>

  {canEdit(post.authorId || post.userId) && (
    <>
      <span
        className="Beitrags-edit-icon"
        onClick={(e) => {
          e.stopPropagation();
          setReplyBeingEdited("main");
          setEditedText(post.content);
          setEditedTitle(post.title);
          setEditedCategory(post.category || "");
        }}
        title="Beitrag bearbeiten"
      >
        ✏️
      </span>

      <span
        className="Beitrags-delete-icon"
        onClick={(e) => {
          e.stopPropagation();
          setReplyToDelete("main");
        }}
        title="Beitrag löschen"
      >
        🗑️
      </span>
    </>
  )}

 <ContentActionMenu
  contentType="forumPost"
  contentId={post.id}
  ownerId={post.userId || post.authorId || post.ownerId || null}
  ownerName={post.authorName || "Unbekannt"}

  contentTitle={post.title || "Beitrag bei Edens Ernte"}
  contentText={post.content || ""}

  currentUser={user}
  shareLabel="Beitrag teilen"
  reportLabel="Beitrag melden"
  blockLabel="Nutzer blockieren"
  shareTitle={post.title || "Beitrag bei Edens Ernte"}
  shareText={post.content || ""}
  shareUrl={`/forum/beitrag/${post.id}`}
  onLoginRequired={() => setShowLoginRequiredModal(true)}
  onActionToast={showActionToast}
  onBlockedUser={(blockedUserId) => {
    addBlockedUser(blockedUserId);

    const ownerId = post.userId || post.authorId || post.ownerId || null;

    if (ownerId && String(ownerId) === String(blockedUserId)) {
      navigate("/forum");
    }
  }}
/>
</div>
{formatCreatedDate(post) && (
  <div className="beitrag-created-date">
    Erstellt am {formatCreatedDate(post)}
  </div>
)}

                <h3>{post.title}</h3>
                <p>{post.content}</p>

                <div className="post-image-row">
                  {(post.images || []).map((src, i) => (
                    <img
                      key={i}
                      src={src}
                      alt={`post-img-${i}`}
                      className="preview-image"
                      loading={i === 0 ? 'eager' : 'lazy'}
                      decoding="async"
                      onClick={() => {
  setLightboxImages(post.images || []);
  setLightboxIndex(i);
}}
                    />
                  ))}
                </div>

                <span
  className="author-bottom-right clickable"
  onClick={(e) =>
  handleUserClick(
    post.authorId || post.userId || post.ownerId || null,
    post.authorName || "Unbekannt",
    e
  )
}
>
  Erstellt von {post.authorName}
</span>
              </>
            )}
          </div>
        )}

        {/* ✅ Replies-Hinweis (nicht blockierend) */}
        {post && repliesLoading && showLoadingHint && (
          <p style={{ textAlign: 'center', opacity: 0.7, marginTop: 10 }}>
            ⏳ Antworten werden geladen…
          </p>
        )}

        {/* Antworten */}
        {post &&
          pagedReplies.map((reply) => (
            <div className="reply-box" key={reply.id}>
              {replyBeingEdited === reply.id ? (
                <>
                  <textarea value={editedText} onChange={(e) => setEditedText(e.target.value)} rows="4" />
                  <button className="green-button small" onClick={() => confirmEditReply(reply.id)}>
                    Speichern
                  </button>
                </>
              ) : (
                <>
                {formatCreatedDate(reply) && (
  <div className="beitrag-created-date reply-date">
    Erstellt am {formatCreatedDate(reply)}
  </div>
)}
                  <p>{reply.content}</p>

                  {reply.images && reply.images.length > 0 && (
  <div className="post-image-row">
    {reply.images.map((src, i) => (
      <img
        key={i}
        src={src}
        alt={`reply-img-${i}`}
        className="preview-image"
        loading="lazy"
        decoding="async"
        onClick={() => {
          setLightboxImages(reply.images || []);
          setLightboxIndex(i);
        }}
      />
    ))}
  </div>
)}

                  <div className="reply-actions beitrag-reply-actions">
  {canEdit(reply.authorId || reply.userId) && (
    <>
      <span
        className="Beitrags-edit-icon"
        onClick={(e) => {
          e.stopPropagation();
          handleEditReply(reply);
        }}
        title="Antwort bearbeiten"
      >
        ✏️
      </span>

      <span
        className="Beitrags-delete-icon"
        onClick={(e) => {
          e.stopPropagation();
          setReplyToDelete(reply.id);
        }}
        title="Antwort löschen"
      >
        🗑️
      </span>
    </>
  )}

  <ContentActionMenu
  contentType="forumReply"
  contentId={reply.id}
  parentId={post.id}
  ownerId={reply.userId || reply.authorId || reply.ownerId || null}
  ownerName={reply.authorName || "Unbekannt"}

  contentTitle={`Antwort zu: ${post.title || "Forumbeitrag"}`}
  contentText={reply.content || ""}

  currentUser={user}
  showShare={false}
  showReport={true}
  showBlock={true}
  reportLabel="Antwort melden"
  blockLabel="Nutzer blockieren"
  shareTitle={post.title || "Antwort bei Edens Ernte"}
  shareText={reply.content || ""}
  shareUrl={`/forum/beitrag/${post.id}`}
  onLoginRequired={() => setShowLoginRequiredModal(true)}
  onActionToast={showActionToast}
  onBlockedUser={(blockedUserId) => {
    addBlockedUser(blockedUserId);
  }}
/>
</div>

                  <span
  className="author-bottom-right clickable"
  onClick={(e) =>
  handleUserClick(
    reply.authorId || reply.userId || reply.ownerId || null,
    reply.authorName || "Unbekannt",
    e
  )
}
>
  Antwort von {reply.authorName}
</span>
                </>
              )}
            </div>
          ))}

        {/* Antwortfeld nur auf letzter Seite */}
        {post && currentPage === totalPages && (
          <div className="reply-input">
            <div className="upload-wrapper">
              <textarea
                placeholder="Antwort schreiben..."
                value={newReply}
                onChange={(e) => setNewReply(e.target.value)}
              />
              {replyImages.length === 0 && (
  <img
    src="/upload-icon.png"
    alt="Upload"
    className="beitrags-upload-answer-icon"
    onClick={() => triggerImagePicker(replyFileInputRef, "reply")}
  />
)}
            </div>

            <input
              type="file"
              accept="image/*"
              multiple
              ref={replyFileInputRef}
              onChange={handleImageUpload}
              style={{ display: 'none' }}
            />

            <div className="image-preview-row">
              {replyImages.map((entry, i) => (
                <div
                  key={i}
                  className={`image-item ${mainReplyImageIndex === i ? 'main-image' : ''}`}
                  draggable
                  onDragStart={(e) => handleDragStart(e, i)}
                  onDragOver={(e) => {
                    e.preventDefault();
                    dragOverItem.current = i;
                  }}
                  onDrop={(e) => handleDrop(e, i)}
                >
                  <img src={entry.preview} alt={`preview-${i}`} loading="lazy" decoding="async" />
                  <div className="image-actions">
                    <button onClick={() => handleDeleteImage(i)}>X</button>
                    <button onClick={() => setMainReplyImageIndex(i)}>★</button>
                  </div>
                </div>
              ))}

              {replyImages.length > 0 && replyImages.length < MAX_REPLY_IMAGES && (
  <div
    className="preview-row-add-image-item"
    onClick={() => triggerImagePicker(replyFileInputRef, "reply")}
  >
    <img src="/upload-icon.png" alt="Weiteres Bild hinzufügen" />
  </div>
)}
            </div>

            <button
              className="green-button"
              onClick={() => {
                if (!myUid || !isVerified) {
                  setShowLoginRequiredModal(true);
                  return;
                }
                setShowSendModal(true);
              }}
            >
              Antwort senden
            </button>
          </div>
        )}

        {/* Paginierung */}
        {post && (
          <div className="pagination">
            <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
              ⏮
            </button>
            <button onClick={() => setCurrentPage((prev) => Math.max(prev - 10, 1))}>«</button>
            <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>‹</button>
            <span>
              {currentPage} / {totalPages}
            </span>
            <button onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}>›</button>
            <button onClick={() => setCurrentPage((prev) => Math.min(prev + 10, totalPages))}>»</button>
            <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}>
              ⏭
            </button>
          </div>
        )}
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && lightboxImages?.length > 0 && (
  <div
    className="lightbox-overlay"
    tabIndex={0}
    ref={lightboxRef}
    onKeyDown={(e) => {
      if (e.key === 'Escape') {
        setLightboxIndex(null);
        setLightboxImages([]);
      }
      if (e.key === 'ArrowRight' && lightboxImages.length > 1) showNextImage();
if (e.key === 'ArrowLeft' && lightboxImages.length > 1) showPrevImage();
    }}
    onClick={() => {
      setLightboxIndex(null);
      setLightboxImages([]);
    }}
  >
    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
      <img
        src={lightboxImages?.[lightboxIndex]}
        alt="Lightbox"
        className="lightbox-img"
        decoding="async"
      />
            <div className="lightbox-button-row">
              <button
                className="beitrags-lightbox-button green"
                onClick={(e) => {
                  e.stopPropagation();
                  showPrevImage();
                }}
              >
                ‹ Zurück
              </button>
              <button
                className="beitrags-lightbox-button red"
                onClick={(e) => {
  e.stopPropagation();
  setLightboxIndex(null);
  setLightboxImages([]);
}}
              >
                ✖ Schließen
              </button>
              <button
                className="beitrags-lightbox-button green"
                onClick={(e) => {
                  e.stopPropagation();
                  showNextImage();
                }}
              >
                Weiter ›
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Bestätigungs-Popup fürs Antworten */}
      {showSendModal && (
        <div className="modal-overlay" onClick={() => setShowSendModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Antwort wirklich senden?</h3>
            <div className="modal-buttons">
              <button className="delete-btn" onClick={handleSendReply}>
                Ja
              </button>
              <button className="cancel-btn" onClick={() => setShowSendModal(false)}>
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Lösch-Popup */}
      {replyToDelete !== null && (
        <div className="modal-overlay" onClick={() => setReplyToDelete(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>{replyToDelete === 'main' ? 'Beitrag' : 'Antwort'} wirklich löschen?</h3>
            <p>Diese Aktion kann nicht rückgängig gemacht werden.</p>
            <div className="modal-buttons">
              <button className="delete-btn" onClick={() => handleDeleteReply(replyToDelete)}>
                Löschen
              </button>
              <button className="cancel-btn" onClick={() => setReplyToDelete(null)}>
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Nachrichten-Popup */}
      {showMessageModal && (
        <div className="footer-modal-overlay" onClick={() => setShowMessageModal(false)}>
          <div className="footer-modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Nachricht an {modalRecipient.name}</h3>
            <textarea
              placeholder="Nachricht schreiben..."
              rows="5"
              style={{ width: '100%', marginBottom: '12px' }}
              value={newMessageText}
              onChange={(e) => setNewMessageText(e.target.value)}
            />
            <button className="green-button" onClick={handleSendMessage}>
              Nachricht senden
            </button>
            <button className="red-button" onClick={() => setShowMessageModal(false)} style={{ marginTop: '10px' }}>
              Schließen
            </button>
          </div>
        </div>
      )}

      {/* Floating-Notification für Abo */}
      

      {/* Bildlimit-Popup */}
      {uploadLimitExceeded && (
        <div className="modal-overlay" onClick={() => setUploadLimitExceeded(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Maximal {MAX_REPLY_IMAGES} Bilder erlaubt</h3>
            <div className="modal-buttons">
              <button className="green-button" onClick={() => setUploadLimitExceeded(false)}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 🔐 Login erforderlich */}
      {showLoginRequiredModal && (
        <div className="modal-overlay" onClick={() => setShowLoginRequiredModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Login erforderlich</h3>
            <p>Um diese Funktion nutzen zu können, musst du bei Edens Ernte eingeloggt sein.</p>
            <div className="modal-buttons">
              <button
                className="green-button"
                onClick={() => {
                  setShowLoginRequiredModal(false);
                  navigate('/login');
                }}
              >
                Zum Login
              </button>
              <button className="red-button" onClick={() => setShowLoginRequiredModal(false)}>
                Schließen
              </button>
            </div>
          </div>
        </div>
      )}
      {showCreatingReplyModal && (
  <div className="modal-overlay">
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <h3>Antwort wird erstellt</h3>
      <p>{creatingReplyText}</p>
      <div className="ee-loading-spinner"></div>
    </div>
  </div>
)}
   <ImageSourceModal
  isOpen={showImageSourceModal}
  onClose={() => {
    setShowImageSourceModal(false);
    setImageSourceTarget(null);
  }}
  onCamera={handleChooseCamera}
  onGallery={handleChooseGallery}
/>
    </div>
  );
};

export default ForumsBeitragsPage;